import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\Partners\UpdateDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/UpdateDossierEnaosController.php
* @route '/api/dossier/{dossier}/enaos'
*/
const UpdateDossierEnaosController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierEnaosController.url(args, options),
    method: 'put',
})

UpdateDossierEnaosController.definition = {
    methods: ["put"],
    url: '/api/dossier/{dossier}/enaos',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Dossier\Partners\UpdateDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/UpdateDossierEnaosController.php
* @route '/api/dossier/{dossier}/enaos'
*/
UpdateDossierEnaosController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return UpdateDossierEnaosController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\Partners\UpdateDossierEnaosController::__invoke
* @see app/Http/Controllers/Dossier/Partners/UpdateDossierEnaosController.php
* @route '/api/dossier/{dossier}/enaos'
*/
UpdateDossierEnaosController.put = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateDossierEnaosController.url(args, options),
    method: 'put',
})

export default UpdateDossierEnaosController